import React from "react";

import posbossLogo from "assets/images/posbossLogo.png";
import { useTranslation } from "react-i18next";

import Icon from "Atoms/Icons";
import { WithLoadingComponent } from "Atoms/Loading";

export const LoadingPage = () => {
  const { t } = useTranslation("welcome");

  return (
    <div className="bg-neutral-100">
      <div className="mx-auto flex h-screen w-full max-w-screen-sm flex-col items-center justify-center space-y-32 bg-white">
        <img
          src={posbossLogo}
          alt="posboss Logo"
          className="w-64 animate-pulse"
        />
        <h3 className="text-xl">{t("common.loading")}</h3>
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ ...props }) => {
  return (
    <Icon
      icon="loading"
      className="inline-block animate-spin align-middle"
      {...props}
    />
  );
};

const LoadingError = () => {
  return "failed to load";
};
const Loading = WithLoadingComponent(
  () => (
    <div>
      <LoadingPage />
    </div>
  ),
  () => (
    <div>
      <LoadingError />
    </div>
  ),
);
export { useLoadingState } from "Atoms/Loading";
export default Loading;
